import { ImagesSubComponent } from '../images.sub.component';
import { trackView } from '@otto-ec/nexus-registry/pdp/tracking';

export class VideoLinkSubComponent extends ImagesSubComponent {
    public rootSelector = '.js_pdp_video-link';

    public async onHtmlLoaded(): Promise<void> {
        if (!this.isPresent()) {
            return;
        }
        this.registerClickHandler();
        trackView({
            product_Video: ['view'],
        });
    }

    private registerClickHandler(): void {
        this.getRootElement().addEventListener('click', () => this.handleVideoLinkClick(), false);
    }

    private handleVideoLinkClick() {
        if (this.hasVideo()) {
            this.changeItem(this.getVideoIndex());
        }
    }

    protected onItemChanged() {}
}
